// Studio configuration.
// PLACEHOLDERS marked below — replace with the studio's real details when available.
export const STUDIO = {
  name: "Room 9",
  fullName: "Room 9 Studio",
  tagline: "Modular Production Studio",
  logo: "/room9-logo.png",
};

export const CONTACT = {
  phoneDisplay: "+91 92134 41742",
  phoneHref: "tel:+919213441742",
  whatsappHref: `https://wa.me/919213441742?text=${encodeURIComponent(
    "Hi Room 9! I'd like to enquire about booking the studio."
  )}`,
  email: "roomnine.info@gmail.com",
  address: "909/910, Akshat Tower, Near Pakwan Circle, SG Highway, Bodakdev, Ahmedabad 380015",
  hours: "9:00 AM – 1:00 AM (Midnight)",
};

// Studio pin — SG Highway, Bodakdev, Ahmedabad
export const MAP = {
  lat: 23.0395,
  lon: 72.5115,
  embedUrl:
    "https://www.openstreetmap.org/export/embed.html?bbox=72.4995%2C23.0295%2C72.5235%2C23.0495&layer=mapnik&marker=23.0395%2C72.5115",
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=Akshat+Tower,+SG+Highway,+Bodakdev,+Ahmedabad+380015",
};

export const SOCIALS = [
  {
    id: "instagram",
    label: "Instagram",
    handle: "@room9space",
    href: "https://www.instagram.com/room9space",
  },
];

export const IMAGES = {
  heroStage:
    "https://images.unsplash.com/photo-1471341971476-ae15ff5dd4ea?auto=format&fit=crop&w=1600&q=75",
  mapGraphic:
    "https://images.unsplash.com/photo-1754299375507-72f63a9a065e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGNpdHklMjBtYXAlMjBsb2NhdGlvbnxlbnwwfHx8fDE3OTAyNTE1OTB8MA&ixlib=rb-4.1.0&q=85",
};


// Photo categories managed in /admin (max 4 photos each), shown on Props & Backdrops cards.
export const PHOTO_CATEGORIES = [
  { id: "small-vases", label: "Vases" },
  { id: "rugs", label: "Rugs" },
  { id: "artificial-plants", label: "Artificial Plants" },
  { id: "chairs", label: "Chairs" },
  { id: "european-style-wall", label: "European-Style Wall" },
  { id: "painted-arch-backdrop", label: "Painted Arch Backdrop" },
  { id: "printed-wall-backdrop", label: "Printed Wall Backdrop" },
  { id: "clothing-rack", label: "Clothing Rack" },
  { id: "paper-backdrops", label: "Paper Backdrops" },
];